import classnames from 'classnames'
import { arrayOf, node, oneOfType, string } from 'prop-types'
import React from 'react'
import '../../../stylesheets/custom_scrollbar.scss'
import './ScrollingListBox.scss'

const ScrollingListBox = ({ elementId, children, className }) => {
    return (
        <div id={elementId} className={classnames('scrolling-list', className)}>
            <div className='custom-scroll'>
                {children}
            </div>
        </div>
    )
}

ScrollingListBox.propTypes = {
    elementId: string.isRequired,
    children: oneOfType([arrayOf(node), node])
}

export default ScrollingListBox